import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center gap-2">
    <div className="flex-1 flex flex-col gap-1">
      <div className="w-full h-2 bg-zinc-300 dark:bg-zinc-600 rounded" />
      <div className="w-3/4 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
      <div className="w-6 h-2.5 bg-primary/40 rounded mt-1" />
    </div>
    <div className="w-10 h-12 bg-zinc-200 dark:bg-zinc-700 rounded" />
  </div>
);

export default Thumbnail;
